import { countryCodes, HeaderBidder, unitedStatesTerritories } from '@tunein/web-common';
import { Singleton } from '@tunein/web-utils';
import { PARTNER_ADS_CONFIG } from '../constants';
import { debug } from '../utils';
const PARTNER_ALIAS_PLACEHOLDER = '{partnerAlias}';
function isLegacyConfig(config) {
    return 'providers' in config;
}
class ApiSingleton extends Singleton {
    // TODO: consider moving this to Api Client. We could potentially group location data helpers in an API like
    //  `api.geo.isInUs`, but until we have more real use cases, we shouldn't eagerly pollute WAC.
    get isInUS() {
        const countryCode = this.instance.locationData?.country_code;
        return Boolean(countryCode === countryCodes.US || unitedStatesTerritories[countryCode]);
    }
    init(instance) {
        if (this.instance) {
            return;
        }
        this.instance = instance;
        // Route header-bidder init failures through the telemetry pipeline without
        // coupling `@tunein/web-common` to player-manager. Sub-bidders log at most
        // once per bidder lifetime, so this is a low-volume channel.
        HeaderBidder.setInitErrorLogger((message, context) => {
            this.logError(message, context);
        });
    }
    logError(message, context = {}, printDebugLog = true) {
        if (printDebugLog) {
            debug(message, context);
        }
        return this.instance.telemetry.logError({ message, context });
    }
    getAdUnitConfig(clientType, medium) {
        const config = this.instance.getConfigSetting(PARTNER_ADS_CONFIG);
        if (!config) {
            return;
        }
        let provider;
        let adUnitConfig;
        if (isLegacyConfig(config)) {
            const legacyEntry = config[clientType]?.[medium];
            if (legacyEntry) {
                provider = legacyEntry.provider;
                adUnitConfig = legacyEntry;
            }
        }
        else {
            for (const [key, providerConfig] of Object.entries(config)) {
                const entry = providerConfig?.[medium]?.[clientType];
                if (entry?.adUnitId) {
                    provider = key;
                    adUnitConfig = entry;
                    break;
                }
            }
        }
        if (!adUnitConfig?.adUnitId || !provider) {
            return;
        }
        const adUnitId = adUnitConfig.adUnitId.replace(PARTNER_ALIAS_PLACEHOLDER, this.instance.adsTargeting.ads_partner_alias || '');
        return {
            ...adUnitConfig,
            adUnitId,
            provider,
        };
    }
    getPrebiddingConfig(clientType) {
        return this.getAdUnitConfig(clientType, 'video')?.prebidding;
    }
}
export const api = new ApiSingleton();
export function getExperiment(key, fallback) {
    return api.getConfigSetting(key, fallback);
}
